import React from 'react';
import { ShieldCheck, Clock, BadgeDollarSign, ThumbsUp } from 'lucide-react';
const REASONS = [{
  title: '24/7 Fast Response',
  description: 'Plumbing emergencies do not wait. We are ready to deploy at a moments notice to protect your home.',
  icon: Clock
}, {
  title: 'Arizona Native',
  description: 'Born and raised in Arizona. We know the Valley and we are proud to serve our local community.',
  icon: ShieldCheck
}, {
  title: 'Licensed & Insured',
  description: 'Fully licensed, bonded, and insured (ROC #364179) for your complete peace of mind.',
  icon: BadgeDollarSign
}, {
  title: 'Advanced Technology',
  description: 'From camera sewer inspections to modern leak detection, we use the best tech available.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-24 bg-dark relative" data-id="element-257">
      <div className="container mx-auto px-4" data-id="element-258">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-259">
          <div className="lg:w-1/2" data-id="element-260">
            <div className="text-left mb-12" data-id="element-261">
              <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-262">
                Why Choose <span className="text-accent" data-id="element-263">Alien Plumbing</span>
              </h2>
              <p className="text-slate-400 text-lg" data-id="element-264">
                We are committed to providing out-of-this-world plumbing
                services to our Phoenix Valley neighbors, ensuring your home is
                safe, clean, and functioning perfectly.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-265">
              {REASONS.map((reason, idx) => <div key={idx} className="flex flex-col items-start text-left relative" data-id="element-266">
                  <div className="h-16 w-16 rounded-full bg-surface border-2 border-accent flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(57,255,20,0.15)]" data-id="element-267">
                    <reason.icon className="h-8 w-8 text-accent" data-id="element-268" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-269">
                    {reason.title}
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-270">{reason.description}</p>
                </div>)}
            </div>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-271">
            <img src="https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=80&w=1000&auto=format&fit=crop" alt="Clean bathroom vanity sink with a modern faucet" className="rounded-2xl shadow-2xl border-2 border-accent/20 w-full h-auto object-cover max-h-[600px]" data-id="element-272" />
          </div>
        </div>
      </div>
    </section>;
}